import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_tree_select = _resolveComponent("n-tree-select")!
  const _component_n_form_item = _resolveComponent("n-form-item")!

  return (_openBlock(), _createBlock(_component_n_form_item, {
    rule: {
      type: 'number',
      required: $props.required,
      message: $props.message,
      trigger: ['blur', 'change', 'update'],
    },
    label: $props.label,
    class: _normalizeClass('col-md-' + $props.col + '  mb-' + $props.mb),
    path: $props.path,
    isRtl: true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_tree_select, {
        cascade: "",
        checkable: "",
        "check-strategy": "child",
        options: $props.options,
        multiple: $props.multiple,
        clearable: "",
        size: _ctx.formSetting.formSize,
        value: $setup.MyValue,
        "onUpdate:value": [
          _cache[0] || (_cache[0] = ($event: any) => (($setup.MyValue) = $event)),
          _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:value', $props.value)))
        ],
        "max-tag-count": $props.max
      }, null, 8, ["options", "multiple", "size", "value", "max-tag-count"])
    ]),
    _: 1
  }, 8, ["rule", "label", "class", "path"]))
}